import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './EditBlog.css';

const EditBlog = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Extract the blog from state (fallback to undefined if not provided)
  const { blog } = state || {};
  const [updatedBlog, setUpdatedBlog] = useState(blog || {});
  const [selectedImage, setSelectedImage] = useState(null); // For the new image file
  const [loading, setLoading] = useState(false); // Loading state for update request
  const [error, setError] = useState(null); // Error state for feedback

  useEffect(() => {
    // Log the initial blog state
    console.log('Initial blog state:', blog);

    if (!blog) {
      alert('No blog data provided. Redirecting to the blog list...');
      navigate('/blog'); // Redirect to blogs page if no blog data is passed
    }
  }, [blog, navigate]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedBlog((prev) => ({ ...prev, [name]: value }));

    // Log updated blog state after every input change
    console.log('Updated blog state (after input change):', {
      ...updatedBlog,
      [name]: value,
    });
  };

  // Handle image file selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file); // Save the selected file

    // Log the selected image file
    console.log('Selected image file:', file);
  };

  // Handle blog update
  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    try {
      // Create FormData to handle file uploads
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          id: updatedBlog.id,
          title: updatedBlog.title,
          category: updatedBlog.category,
          content: updatedBlog.content,
          description: updatedBlog.description,
        })
      );
      
      if (selectedImage) {
        formData.append('image', selectedImage); // Send the new image
      }
  
      const response = await fetch(
        'https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/edit_blog.php',
        {
          method: 'POST',
          body: formData, // Send FormData as the body
        }
      );
  
      const responseData = await response.json();
      console.log('Server Response:', responseData); // Debugging
  
      if (response.ok && responseData.success) {
        alert('Blog updated successfully!');
        navigate('/blog'); // Redirect to blogs page
      } else {
        setError(responseData.message || 'Failed to update the blog. Please try again.');
      }
    } catch (error) {
      console.error('Error updating blog:', error);
      setError('An error occurred while updating the blog. Please try again.');
    } finally {
      setLoading(false);
      navigate('/blog'); // Redirect to blogs page
    }
  };
  

  return (
    <div className="edit-blog-page">
      <h1>Edit Blog</h1>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleUpdate} className="edit-blog-form">
        {/* Blog Title */}
        <input
          type="text"
          name="title"
          placeholder="Blog Title"
          value={updatedBlog.title || ''}
          onChange={handleInputChange}
          required
        />

        {/* Blog Description */}
        <textarea
          name="description"
          placeholder="Blog Description"
          value={updatedBlog.description || ''}
          onChange={handleInputChange}
          required
        />

        {/* Blog Category */}
        <input
          type="text"
          name="category"
          placeholder="Category"
          value={updatedBlog.category || ''}
          onChange={handleInputChange}
          required
        />

        {/* Blog Content */}
        <textarea
          name="content"
          placeholder="Content"
          value={updatedBlog.content || ''}
          onChange={handleInputChange}
          required
        />

        {/* Current Image */}
        {updatedBlog.image && (
          <div className="current-image">
            <p>Current Image:</p>
            <img
              src={updatedBlog.image} // Assuming the image URL is in the `image` field
              alt="Blog"
              style={{ maxWidth: '200px', maxHeight: '200px' }}
            />
          </div>
        )}

        {/* New Image Input */}
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleImageChange}
        />

        {/* Submit Button */}
        <button type="submit" className="update-blog-button" disabled={loading}>
          {loading ? 'Updating...' : 'Update Blog'}
        </button>
      </form>
    </div>
  );
};

export default EditBlog;
